

export const SOURCE = "https://www.safe182.go.kr/home/lcm/lcmMssList.do?rptDscd=2";
